<div class="tricare-container">
  <div class="heart-image">
    <img
      alt="pause image"
      src="/assets/heart-hands.svg"
    >
  </div>
  <h2>We’ll help you activate your coverage</h2>

  <p class="body">As an active duty member, your care requires specific authorization details. 
  To ensure everything is set up correctly and covered, our Care Coordination team 
  will personally assist you.</p>
  <div class="reach-out-container">
    <h4>Reach out to our care coordination team to get setup</h4>
    <h2>
      <iris-icon name="call"></iris-icon>
      844-THERAPY
    </h2>
  </div>
</div>
